module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_vm._v("Vegetarians")]), _vm._v(" "), _c('p', {
    staticClass: "BT-Opener"
  }, [_c('span', {
    staticClass: "Drop _idGenCharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "Drop CharOverride-9"
  }), _vm._v("think it’s awesome that he’s a vegetarian, too; none of my friends are, and the girls are always teasing me about it. But we’ve banded together in our meat-free lifestyle—plus, he’s a great vegetarian cook, so I’m learning a lot. I’ve started to eat a much more balanced diet. I’ve graduated from grilled cheese and fries. He thinks it’s offensive when people invite him to dinner and then offer him meat—and all his girlfriends have been vegetarians. He thinks girls who eat meat are repulsive. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b2a013","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802157409-7.vue
// module id = 84
// module chunks = 0